module.exports = __webpack_public_path__ + "media/components/assets/img/bg/circle-shape-tl-e064aa48748e12dbb4b8644d0ca35d4b.svg";